<template>
  <v-card>
    <v-card-text>
      <v-progress-linear
        indeterminate
        color="primary"
        v-show="loadingCurrencies"
      ></v-progress-linear>
      <h3>Внутренние курсы валют поставщика</h3>
      <v-row justify="end">
        <v-col cols="5">
          <v-btn
            color="primary"
            :disabled="loadingCurrencies"
            @click="updateSupplierRates()"
            >Обновить курс валют</v-btn
          >
        </v-col>
      </v-row>
      <v-data-table-virtual
        :headers="headers"
        :items="rates"
        height="350px"
      ></v-data-table-virtual>
    </v-card-text>
  </v-card>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const SuppliersRepository = RepositoryFactory.get("suppliers");
export default {
  props: ["currentSupplier"],
  data() {
    return {
      loadingCurrencies: false,
      rates: [],
      headers: [
        {
          title: "Валюта",
          align: "start",
          sortable: false,
          key: "currencyName",
        },
        {
          title: "Дата обновления",
          align: "start",
          sortable: false,
          key: "createdAt",
        },
        {
          title: "Стоимость",
          align: "start",
          sortable: false,
          key: "rate",
        },
      ],
    };
  },
  watch: {
    currentSupplier() {
      if (this.currentSupplier) {
        this.getRates(this.currentSupplier.id);
        //this.updateSupplierRates();
      }
    },
  },
  mounted() {
    if (this.currentSupplier) {
      this.getRates(this.currentSupplier.id);
      //this.updateSupplierRates();
    }
  },
  methods: {
    async updateSupplierRates() {
      this.loadingCurrencies = true;
      const result = await SuppliersRepository.updateSupplierRates(
        this.currentSupplier.id
      );
      if (result) {
        await this.getRates(this.currentSupplier.id);
      }
      this.loadingCurrencies = false;
    },
    async getRates(id) {
      const result = await SuppliersRepository.getSupplierRates(id);
      if (result) {
        this.rates = result.data.data;
      }
    },
  },
};
</script>
